import { googleLogout } from "@react-oauth/google";
import { hasSeenCreditsModal, setCredits } from "./creditActions";
import {
  FETCH_BOOKMARK_GROUPS_RESET,
  FETCH_CASES_RESET,
  FETCH_STATUTES_RESET,
} from "../store/Bookmarks/bookmarksTypes";
import { loginApi, signUpApi } from "../services/api/authApi";
import {
  ACTIVE_CHAT_KEY,
  CONTRACT_ANALYSIS_ACTIVE_SESSION_KEY,
  CONTRACT_ANALYSIS_SESSIONS_KEY,
  DOCUMENT_CHAT_STORAGE_KEY,
  USER_INFO_KEY,
} from "../utils/HelperFunction/Constants";
import { setEncryptedItem, removeStorageItem } from "../utils/storageUtils";

export const login = (username, password) => async (dispatch) => {
  try {
    dispatch({
      type: "USER_LOGIN_REQUEST",
    });

    const response = await loginApi(username.toLowerCase(), password);
    const data = response.data;
    console.log("user login data", data);
    const userInfo = {
      ...data,
      role: data.role || data.user?.role || data.data?.role || "user",
    };
    setEncryptedItem(USER_INFO_KEY, userInfo);
    dispatch({
      type: "USER_LOGIN_SUCCESS",
      payload: data,
    });
    dispatch(
      setCredits(
        data.credits,
        data._id,
        data.creditExpiration,
        data.creditRequestCount,
      ),
    );

    dispatch(hasSeenCreditsModal(data.hasSeenModal));
  } catch (error) {
    dispatch({
      type: "USER_LOGIN_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const logout = () => async (dispatch) => {
  removeStorageItem(USER_INFO_KEY);
  removeStorageItem(DOCUMENT_CHAT_STORAGE_KEY);
  removeStorageItem(ACTIVE_CHAT_KEY);
  removeStorageItem(CONTRACT_ANALYSIS_SESSIONS_KEY);
  removeStorageItem(CONTRACT_ANALYSIS_ACTIVE_SESSION_KEY);
  removeStorageItem("pending_psid");
  removeStorageItem("pending_psid_data");
  localStorage.setItem("logout", Date.now().toString()); // cross-tab logout signal — value not sensitive
  googleLogout();
  dispatch({ type: "USER_LOGOUT" });
  dispatch({ type: "GET_CHAT_TITLES_RESET" });
  dispatch({ type: FETCH_BOOKMARK_GROUPS_RESET });
  dispatch({ type: FETCH_CASES_RESET });
  dispatch({ type: FETCH_STATUTES_RESET });
  dispatch({ type: "GET_PETITION_TITLES_RESET" });
  dispatch({ type: "GET_APPLICATION_TITLES_RESET" });
  window?.Tawk_API?.setAttributes({}); // Clear attributes
  // window.location.replace("/");
};

export const signUp =
  (
    fullName,
    email,
    phoneNumber,
    password,
    cnic,
    // userType,
    // organization,
    // designation,
    // officeAddress,
    // barCouncil
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "USER_SIGNUP_REQUEST",
      });
      console.log("sign up data", fullName, email, phoneNumber, password, cnic);
      const response = await signUpApi(
        fullName,
        email?.toLowerCase(),
        phoneNumber,
        password,
        cnic,
      );
      const { data, status } = response;
      setEncryptedItem(USER_INFO_KEY, data);
      dispatch({
        type: "USER_SIGNUP_SUCCESS",
        payload: { data, status },
      });
    } catch (error) {
      dispatch({
        type: "USER_SIGNUP_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateUserPlan = (newPlanId) => (dispatch, getState) => {
  const { userLogin } = getState();
  const currentUserInfo = userLogin?.userInfo;

  if (currentUserInfo) {
    const updatedUserInfo = {
      ...currentUserInfo,
      currentPlanId: newPlanId,
      planId: newPlanId,
      ...(currentUserInfo.user && {
        user: {
          ...currentUserInfo.user,
          currentPlanId: newPlanId,
          planId: newPlanId,
        },
      }),
    };

    // 1. Sync encrypted storage so persistent reloads maintain the state
    setEncryptedItem(USER_INFO_KEY, updatedUserInfo);

    // 2. Dispatch to Redux store to trigger instantaneous UI updates
    dispatch({
      type: "USER_UPDATE_PLAN",
      payload: { currentPlanId: newPlanId },
    });
  }
};

export const updateUserPlanExpiration =
  (planExpiration) => (dispatch, getState) => {
    const { userLogin } = getState();
    const currentUserInfo = userLogin?.userInfo;

    if (currentUserInfo) {
      const updatedUserInfo = {
        ...currentUserInfo,
        planExpiration,
        ...(currentUserInfo.user && {
          user: {
            ...currentUserInfo.user,
            planExpiration,
          },
        }),
      };

      // Keep encrypted storage synchronized
      setEncryptedItem(USER_INFO_KEY, updatedUserInfo);

      // Update Redux
      dispatch({
        type: "USER_UPDATE_PLAN_EXPIRATION",
        payload: { planExpiration },
      });
    }
  };

export const updateUserCredits = (newCredits) => (dispatch, getState) => {
  const { userLogin } = getState();
  const currentUserInfo = userLogin?.userInfo;

  if (currentUserInfo) {
    const userId = currentUserInfo._id || currentUserInfo.user?._id;
    const creditExpiration =
      currentUserInfo.creditExpiration ||
      currentUserInfo.user?.creditExpiration;
    const creditRequestCount =
      currentUserInfo.creditRequestCount ||
      currentUserInfo.user?.creditRequestCount;

    const updatedUserInfo = {
      ...currentUserInfo,
      credits: newCredits,
      ...(currentUserInfo.user && {
        user: {
          ...currentUserInfo.user,
          credits: newCredits,
        },
      }),
    };

    // 1. Sync encrypted storage so persistent reloads maintain the state
    setEncryptedItem(USER_INFO_KEY, updatedUserInfo);

    // 2. Update dedicated Credits Reducer (which other UI components subscribe to)
    dispatch(
      setCredits(newCredits, userId, creditExpiration, creditRequestCount),
    );

    // 3. Update userLogin Reducer state
    dispatch({
      type: "USER_UPDATE_CREDITS",
      payload: { credits: newCredits },
    });
  }
};
